module.exports = __webpack_public_path__ + "assets/dee8019d51880f1e9f6687e8ad89e8d5.png";